<template>
    <div class="p-4 border border-solid border-1 border-stone-100 bg-stone-200 text-zinc-900 dark:border-surface-500 dark:bg-surface-950 dark:text-white text-xl">
        <slot></slot>
    </div>
</template>